import { createContext, FC, ReactElement, ReactNode, useContext } from 'react';
import AuthStore from './AuthStore';
import BookkeepingStore from './bookkeeping/BookkeepingStore';
import CashRegisterStore from './CashRegisterStore';
import CompanyStore from './CompanyStore';
import DashboardStore from './Dashboard';
import ProductStore from './ProductStore';
import ReceiptStore from './ReceiptStore';
import RegisterStore from './RegisterStore';
import SearchStore from './SearchStore';
import PaymentMethodStore from './PaymentMethodStore';
import EditPaymentMethodStore from './EditPaymentMethodStore';
import SubscriptionStore from './SubscriptionStore';
import SubscriptionsAdminStore from './SubscriptionsAdminStore';
import ResellerStore from './ResellerStore';
import EditProductStore from './EditProductStore';
import PrinterStore from './PrinterStore';
import AlertStore from './AlertStore';

export class RootStore {
  authStore: AuthStore;

  searchStore: SearchStore;

  registerStore: RegisterStore;

  dashboardStore: DashboardStore;

  companyStore: CompanyStore;

  receiptStore: ReceiptStore;

  bookkeepingStore: BookkeepingStore;

  productStore: ProductStore;

  cashRegisterStore: CashRegisterStore;

  paymentMethodStore: PaymentMethodStore;

  editPaymentMethodStore: EditPaymentMethodStore;

  SubscriptionsAdminStore: SubscriptionsAdminStore;

  subscriptionStore: SubscriptionStore;

  resellerStore: ResellerStore;

  editProductStore: EditProductStore;

  printerStore: PrinterStore;

  alertStore: AlertStore;

  constructor() {
    this.authStore = new AuthStore();
    this.searchStore = new SearchStore(this.authStore);
    this.registerStore = new RegisterStore();
    this.dashboardStore = new DashboardStore(this.authStore);
    this.companyStore = new CompanyStore();
    this.receiptStore = new ReceiptStore(this.companyStore);
    this.bookkeepingStore = new BookkeepingStore(this.companyStore);
    this.productStore = new ProductStore(this.companyStore);
    this.bookkeepingStore = new BookkeepingStore(this.companyStore);
    this.subscriptionStore = new SubscriptionStore(this.companyStore);
    this.cashRegisterStore = new CashRegisterStore(this.companyStore);
    this.editPaymentMethodStore = new EditPaymentMethodStore();
    this.paymentMethodStore = new PaymentMethodStore(
      this.companyStore,
      this.editPaymentMethodStore,
    );
    this.SubscriptionsAdminStore = new SubscriptionsAdminStore(this.authStore);
    this.resellerStore = new ResellerStore(this.authStore);
    this.editProductStore = new EditProductStore();
    this.printerStore = new PrinterStore(this.companyStore);
    this.alertStore = new AlertStore();
  }
}
export const rootStore = new RootStore();

export const StoreContext = createContext<RootStore>(rootStore);

export type StoreComponent = FC<{
  store: RootStore;
  children: ReactNode;
}>;

export const StoreProvider: StoreComponent = ({
  // eslint-disable-next-line react/prop-types
  store,
  // eslint-disable-next-line react/prop-types
  children,
}): ReactElement => <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;

export const useAuth = (): AuthStore => useContext(StoreContext).authStore;

export const useSearch = (): SearchStore => useContext(StoreContext).searchStore;

export const useRegister = (): RegisterStore => useContext(StoreContext).registerStore;
export const useDashboard = (): DashboardStore => useContext(StoreContext).dashboardStore;
export const useCompany = (): CompanyStore => useContext(StoreContext).companyStore;
export const useReceipt = (): ReceiptStore => useContext(StoreContext).receiptStore;
export const useBookkeeping = (): BookkeepingStore => useContext(StoreContext).bookkeepingStore;
export const useProduct = (): ProductStore => useContext(StoreContext).productStore;
export const useSubscription = (): SubscriptionStore => useContext(StoreContext).subscriptionStore;
export const useCashRegister = (): CashRegisterStore => useContext(StoreContext).cashRegisterStore;
export const usePaymentMethod = (): PaymentMethodStore =>
  useContext(StoreContext).paymentMethodStore;
export const useSubscriptionsAdmin = (): SubscriptionsAdminStore =>
  useContext(StoreContext).SubscriptionsAdminStore;
export const useEditPaymentMethodStore = () => useContext(StoreContext).editPaymentMethodStore;
export const useResellerStore = () => useContext(StoreContext).resellerStore;
export const useEditProductStore = () => useContext(StoreContext).editProductStore;
export const usePrinterStore = () => useContext(StoreContext).printerStore;

export const useAlertStore = () => useContext(StoreContext).alertStore;
